import { history } from 'umi';
import React, { useState, useMemo, useRef } from 'react';
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Tooltip,
  useTheme,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'dva';
import dayjs from 'dayjs';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import TablePageStyled from './TablePageStyled.jsx';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import ClearIconML from '@/components/ClearIconML/index';
import { fmtThousand } from '@/utils/comUtil';

const TablePage = (props) => {
  const {
    setPageData,
    pagination,
    sortField,
    setSortField = () => {},
    setSort,
  } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  // 列表数据和loading
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['crowdManage/getCrowdList'];
  const { crowdPageList, configList } = useSelector(
    (state) => state.crowdManage,
  );
  const { data, total } = crowdPageList || {};
  const exportRef = useRef();
  //关于排序问题
  const [GROUP_TITLE, setTitleSort] = useState(true);
  const [GROUP_QUANTITY, setQuantitySort] = useState(true);
  const [GROUP_SUCCESS_COMPUTE_TIME, setSuccessComputeTimeSort] =
    useState(true);
  const [GROUP_UPDATE_STRATEGY, setUpdateStrategyNameSort] = useState(true);
  const [GROUP_STATUS, setStatusNameSort] = useState(true);
  const [GROUP_CREATE_BY, setCreateNameSort] = useState(true);
  const [GROUP_TYPE, setTypeSort] = useState(true);
  const [GROUP_CREATEDATE, setCreateDateSort] = useState(true);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState();
  const [idType, setIdType] = useState('');
  const [labelError, setLabelError] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  // column排序
  useMemo(() => {
    setSort(GROUP_TITLE);
  }, [GROUP_TITLE, setSort]);
  useMemo(() => {
    setSort(GROUP_QUANTITY);
  }, [GROUP_QUANTITY, setSort]);
  useMemo(() => {
    setSort(GROUP_SUCCESS_COMPUTE_TIME);
  }, [GROUP_SUCCESS_COMPUTE_TIME, setSort]);
  useMemo(() => {
    setSort(GROUP_UPDATE_STRATEGY);
  }, [GROUP_UPDATE_STRATEGY, setSort]);
  useMemo(() => {
    setSort(GROUP_STATUS);
  }, [GROUP_STATUS, setSort]);
  useMemo(() => {
    setSort(GROUP_CREATE_BY);
  }, [GROUP_CREATE_BY, setSort]);
  useMemo(() => {
    setSort(GROUP_TYPE);
  }, [GROUP_TYPE, setSort]);
  useMemo(() => {
    setSort(GROUP_CREATEDATE);
  }, [GROUP_CREATEDATE, setSort]);

  // 操作 编辑/详情
  const handleMemberDetail = (record, linkStatus) => {
    let url = '';

    if (record.type === 3) {
      url = '/profile/crowd_manage/crowd_import';
    } else if (linkStatus === 'detail') {
      url = '/profile/crowd_manage/crowd_detail';
    } else {
      url = '/profile/crowd_manage/crowd_edit';
    }
    history.push({
      pathname: url,
      query: {
        tagId: record.id,
        opt: linkStatus,
      },
    });
  };
  // 人群画像
  const handleCrowdPortrayal = (record, linkStatus) => {
    history.push({
      pathname:
        linkStatus === 'portrayal'
          ? '/profile/crowd_manage/crowd_portrayal'
          : '/profile/crowd_manage/crowd_edit',
      query: {
        groupId: record.id,
      },
    });
  };
  //总条数

  const columns = [
    {
      align: 'center',
      title: '人群名称',
      id: 'title',
      key: 'GROUP_TITLE',
      fieldSort: GROUP_TITLE,
      setSort: setTitleSort,
      isSort: true,
      width: 180,
      render: (tableData) => {
        return (
          <div className="tips">
            {tableData.title}
            <Tooltip
              title={tableData.remark || '暂无备注'}
              placement="top"
              arrow
            >
              <ErrorOutlineIcon
                sx={{
                  width: '10px',
                  height: '10px',
                  color: '#1565C0',
                  marginBottom: '5px',
                  marginLeft: '5px',
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: '人群类型',
      align: 'center',
      id: 'type',
      key: 'GROUP_TYPE',
      width: 120,
      fieldSort: GROUP_TYPE,
      setSort: setTypeSort,
      isSort: true,
      render: (row) => {
        return row.type === 2 ? '自定义人群' : '外部人群';
      },
    },
    {
      title: '人数',
      align: 'center',
      id: 'quantity',
      key: 'GROUP_QUANTITY',
      width: 120,
      fieldSort: GROUP_QUANTITY,
      setSort: setQuantitySort,
      isSort: true,
      render: (item) => {
        return (
          <span textAlign="center">
            {item.quantity !== null ? fmtThousand(item.quantity, 0) : ''}
          </span>
        );
      },
    },
    {
      title: '创建时间',
      align: 'center',
      id: 'createDate',
      key: 'GROUP_CREATEDATE',
      width: 180,
      fieldSort: GROUP_CREATEDATE,
      setSort: setCreateDateSort,
      isSort: true,
      render: (row) => {
        return row.createDate
          ? dayjs(row.createDate).format('YYYY-MM-DD HH:mm')
          : '-';
      },
    },
    {
      title: '最新成功计算时间',
      align: 'center',
      id: 'successComputeTime',
      key: 'GROUP_SUCCESS_COMPUTE_TIME',
      width: 180,
      fieldSort: GROUP_SUCCESS_COMPUTE_TIME,
      setSort: setSuccessComputeTimeSort,
      isSort: true,
    },
    {
      title: '更新方式',
      id: 'updateStrategyName',
      key: 'GROUP_UPDATE_STRATEGY',
      width: 140,
      align: 'center',
      fieldSort: GROUP_UPDATE_STRATEGY,
      setSort: setUpdateStrategyNameSort,
      isSort: true,
    },
    {
      title: '状态',
      id: 'statusName',
      key: 'GROUP_STATUS',
      align: 'center',
      width: 120,
      fieldSort: GROUP_STATUS,
      setSort: setStatusNameSort,
      isSort: true,
    },
    {
      title: '创建者',
      id: 'createName',
      key: 'GROUP_CREATE_BY',
      width: 140,
      align: 'center',
      fieldSort: GROUP_CREATE_BY,
      setSort: setCreateNameSort,
      isSort: true,
    },
    {
      title: '操作',
      width: 200,
      align: 'center',
      render: (recor) => {
        const canClick = [1, 2].includes(recor.computeStatus);
        const canDownload = [1].includes(recor.computeStatus);
        return (
          <div align="center" className={'handle_btn'}>
            <ButtonTip title="编辑">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_management_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                disabled={!canClick}
                onClick={() => handleMemberDetail(recor, 'edit')}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canClick
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="详情">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className=""
                onClick={() => handleMemberDetail(recor, 'detail')}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="下载">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_management_list_download',
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                // className="no-drop"
                color="inherit"
                disabled={!canDownload}
                onClick={() => {
                  setRowData(recor);
                  setOpen(true);
                }}
              >
                <SvgIconML
                  name="downLoadFile"
                  size={24}
                  fill={
                    canDownload
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="人群画像">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_management_list_image',
                  events: ['_ev', '_ec'],
                  params: {
                    id: recor.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                disabled={!canDownload}
                onClick={() => handleCrowdPortrayal(recor, 'portrayal')}
              >
                <SvgIconML
                  name="portrayal"
                  size={24}
                  fill={
                    canDownload
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  //添加子标签content
  const groupEditContent = () => {
    return (
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px 0',
            height: '68px',
          }}
        >
          <FormControl
            variant="standard"
            className="gender"
            sx={{ width: '336px' }}
          >
            <InputLabel>
              <span style={{ color: 'red' }}>*</span>输出ID类型
            </InputLabel>
            <Select
              className="select"
              value={idType}
              onChange={(e) => {
                e.target.value && setLabelError({ idType: false });
                setIdType(e.target.value);
              }}
            >
              {configList.map((item) => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  name={item.exportFileName}
                >
                  {item.exportFileName}
                </MenuItem>
              ))}
            </Select>
            <ClearIconML
              handleClick={() => {
                setIdType('');
                setLabelError({ idType: false });
              }}
              clearValue={idType}
            ></ClearIconML>
            <FormHelperText error={labelError?.idType}>
              {labelError?.idType && '输出ID类型必选'}
            </FormHelperText>
          </FormControl>
          {/* <FormControl
            variant="standard"
            className="gender"
            sx={{ width: '336px' }}
          >
            <InputLabel>
              <span style={{ color: 'red' }}>*</span>
              加密方式
            </InputLabel>
            <Select
              className="select"
              value={encodeType}
              onChange={(e) => {
                e.target.value &&
                  setLabelError({ ...labelError, encodeType: false });
                setEncodeType(e.target.value);
              }}
            >
              {PROFILE_EXPORT_ENCRYPTION_METHOD_MEMO.map((item) => (
                <MenuItem
                  key={item.dictCode}
                  value={item.dictCode}
                  name={item.nameZh}
                >
                  {item.nameZh}
                </MenuItem>
              ))}
            </Select>
            <ClearIconML
              handleClick={() => {
                setEncodeType('');
                setLabelError({ ...labelError, encodeType: false });
              }}
              clearValue={encodeType}
            ></ClearIconML>
            <FormHelperText error={labelError?.encodeType}>
              {labelError?.encodeType && '加密方式必选'}
            </FormHelperText>
          </FormControl> */}
        </Box>
      </Box>
    );
  };
  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
        >
          取消
        </Button>
        <Button
          ref={exportRef}
          data-log={JSON.stringify({
            oid: 'btn_user_profile_management_list_export',
            events: ['_ev'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            mountParentSelector: '#export_id_mount_parent',
          })}
          sx={{
            width: '100px!important',
            display: 'flex',
            justifyContent: 'center',
            gap: '0 8px',
          }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          <SvgIconML name="export-icon" size={16}></SvgIconML>导出
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto', top: '0px' };
  };

  const onCloseDialog = () => {
    setLabelError(null);
    setIdType('');
    setOpen(false);
  };

  const onSaveLabelDialog = () => {
    if (!idType) {
      setLabelError({
        idType: !idType,
      });
      return false;
    }
    window.NE_DAWN.trigger(exportRef.current, {
      event: '_ec', // 事件名
      params: { groupId: rowData?.id, downloadFieldIds: [idType] }, // 事件公参
    });
    dispatch({
      type: 'crowdManage/groupDownloadMember',
      payload: {
        values: {
          groupId: rowData?.id,
          downloadFieldIds: [idType],
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          setLabelError(null);
          setIdType('');
          setOpen(false);
          setAlertOpen(true);
        }
      },
    });
  };
  const handleClose = () => {
    setAlertOpen(false);
  };
  return (
    <TablePageStyled>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={data}
        columnKey="id"
        sortField={sortField}
        setSortField={setSortField}
        sortType={'singleLine'}
      ></DataTableNativeML>
      <DialogDataML
        open={open}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              人群包导出
            </span>
          </Box>
        }
        content={groupEditContent()}
        handleClose={onCloseDialog}
        button={initButton()}
      />
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          人群包导出中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </TablePageStyled>
  );
};
export default TablePage;
